<template>
  <div class="flex flex-col h-screen bg-slate-50">
    <AppHeader
      toggle-side="left"
      :toggle="showNavigation"
      :ui="{
        // body: 'bg-slate-50',
        content: 'bg-elevated',
      }"
      v-model:open="isMenuOpen"
    >
      <template #right>
        <div
          v-if="user !== undefined"
          class="flex items-center gap-2"
        >
          <div
            v-if="!isNormalUser"
            class="block"
          >
            <UButton
              color="primary"
              variant="outline"
              :ui="{
                base: 'line-clamp-1',
              }"
              :to="{ name: 'admin-slug' }"
              :size="largerOrEqualThanSm ? 'md' : 'sm'"
            >
              ไปหน้าตั้งค่าระบบ
            </UButton>
          </div>
          <AppMenuUserDropdown></AppMenuUserDropdown>
        </div>
      </template>
      <template #body>
        <UNavigationMenu
          v-if="showNavigation"
          @click="isMenuOpen = false"
          orientation="vertical"
          :items="items"
          :ui="{
            link: 'h-10 text-sm font-medium text-slate-500 data-active:text-slate-950 data-active:before:bg-white! data-active:before:shadow-sm',
          }"
        />
      </template>
    </AppHeader>
    <div class="flex flex-col flex-1 overflow-y-auto">
      <UContainer class="mt:10 sm:mt-20 pt-5 sm:pt-1 pb-24">
        <slot />
      </UContainer>
      <div
        v-if="showNavigation && largerOrEqualThanSm"
        :class="[
          'fixed',
          'w-[calc(100vw-1rem)] right-3.5 top-15 px-5 py-5',
          'xl:w-[calc(var(--ui-container))] sm:right-[50.5%] sm:translate-x-[50%]',
          'flex flex-col gap-3',
          'bg-slate-50',
        ]"
      >
        <div class="flex">
          <UNavigationMenu
            orientation="horizontal"
            :items="items"
            :ui="{
              root: 'p-1 bg-slate-100 rounded-lg',
              item: 'p-0',
              link: 'h-9 text-sm font-medium text-slate-500 data-active:text-slate-950 data-active:before:bg-white! data-active:before:shadow-sm',
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NavigationMenuItem } from "@nuxt/ui";
import { breakpointsTailwind } from "@vueuse/core";

const breakpoints = useBreakpoints(breakpointsTailwind);
const largerOrEqualThanSm = breakpoints.greaterOrEqual("sm");

const authStore = useAuthStore();
const { user, isNormalUser } = storeToRefs(authStore);
const chatStore = useChatStore();
const { status: chatStatus, isPrinting, isSending } = storeToRefs(chatStore);

const isMenuOpen = ref(false);
const error = useError();
const showNavigation = computed(() => !error.value);

const items = computed<NavigationMenuItem[][]>(() => [
  [
    {
      label: "สรุปรายงาน",
      to: { name: "dashboard-prompt" },
      disabled:
        !["abort", "ready"].includes(chatStatus.value) ||
        isSending.value ||
        isPrinting.value,
    },
    {
      label: "จำนวนรายงาน",
      to: { name: "dashboard-statistic" },
      disabled:
        !["abort", "ready"].includes(chatStatus.value) ||
        isSending.value ||
        isPrinting.value,
    },
    {
      label: "เตรียมความรู้พนักงาน",
      to: { name: "dashboard-knowledge" },
      disabled:
        !["abort", "ready"].includes(chatStatus.value) ||
        isSending.value ||
        isPrinting.value,
    },
  ],
]);

onMounted(() => {
  authStore.refreshPreConfig();
});
</script>

<style scoped></style>
